/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */
import React, { FC } from 'react';
import { ProductCard } from '@cloudcar-app/cloudcar-components';
import currencyFormatter from 'utils/currencyFormatter';
import { Popover, Row } from 'antd';
import { CoverageType, InsuranceUseType, PaymentType } from 'apollo/types';
import ProductCardBanner from '../insuranceCardBanner';
import styles from './InsuranceCard.module.scss';

interface InsuranceCardProps {
  name?: string;
  monthlyValue: number;
  period: string;
  selected: boolean;
  details: string;
  coverage: string;
  deductible: number;
  installments?: string | null;
  onClick: () => void;
  pdfUrl?: string | null;
  insuranceCompany: {
    name: string;
    logo: string;
  };
  insuranceType: InsuranceUseType;
  disabled: boolean;
  paymentType: PaymentType;
  monthlyValueInUF: number;
}

const InsuranceCard: FC<InsuranceCardProps> = (props: InsuranceCardProps) => {
  const {
    details,
    selected,
    onClick,
    insuranceCompany,
    disabled,
    deductible,
    monthlyValue,
    monthlyValueInUF,
    coverage,
    period,
    paymentType,
    installments,
    pdfUrl,
  } = props;

  const coverageDetails = JSON.parse(details) as Record<string, string>;

  const colorMapper = () => {
    switch (coverage) {
      case CoverageType.Light:
        return '#00bcd4';
      case CoverageType.Estandar:
        return '#OOADEF';
      case CoverageType.Full:
        return '#8bc34a';
      case CoverageType.AltaGama:
        return '#9c27b0';
      default:
        return '#001118';
    }
  };

  const pdfTextSection = () => {
    return pdfUrl ? (
      <>
        <hr />
        <div
          onClick={(event) => {
            event.stopPropagation();
            window.open(pdfUrl, '_blank');
          }}
        >
          <p className={styles.DownloadInfo}>Descargar PDF</p>
        </div>
      </>
    ) : (
      <>
        <hr />
        <p className={styles.DownloadInfoDisable}>Descargando PDF ...</p>
      </>
    );
  };

  return (
    <Popover
      content={
        <p>Debes esperar la descarga del PDF para seleccionar un producto</p>
      }
      title={false}
      trigger={!pdfUrl && insuranceCompany.name !== 'HDI' ? undefined : []}
    >
      <div>
        <ProductCard
          selected={selected}
          onClick={!disabled ? onClick : () => {}}
          disabled={disabled}
          className={styles.InsuranceCard}
        >
          <img
            src={insuranceCompany.logo}
            alt={insuranceCompany.name}
            className={styles.Logo}
          />
          {coverage && (
            <ProductCardBanner text={coverage} color={colorMapper()} />
          )}
          <div>
            <p className={styles.Info}>Deducible {deductible} UF</p>
            <p className={styles.Info}>Vigencia {period} meses</p>
            <p className={styles.Info}>
              {paymentType === PaymentType.Cash
                ? 'Valor total (UF)'
                : 'Cuota mensual (UF)'}{' '}
              {monthlyValueInUF}
            </p>
            <p className={styles.Info}>
              {paymentType === PaymentType.Cash
                ? 'Valor total referencial'
                : 'Cuota mensual referencial'}{' '}
              {paymentType !== PaymentType.Cash && installments
                ? `${currencyFormatter.format(
                    monthlyValue,
                  )} x ${installments} cuotas`
                : currencyFormatter.format(monthlyValue)}
            </p>
          </div>
          <hr />
          <div className={styles.DetailsSection}>
            {Object.keys(coverageDetails).map((key) => (
              <Row justify="space-between" key={key}>
                <p className={styles.Info}>{key}</p>
                <p className={styles.Info}>{coverageDetails[key]}</p>
              </Row>
            ))}
          </div>
          {pdfTextSection()}
        </ProductCard>
      </div>
    </Popover>
  );
};

export default InsuranceCard;
